export const buttonContainerCss = (assignmentHasContentId: boolean) => ({
  display: assignmentHasContentId ? "flex" : "block",
  flex: "1 0 auto",
});
